/* Eznzza · The Rhode Kit · comportamiento de las secciones rk-* */
(function () {
  if (window.__rhodeKit) return;
  window.__rhodeKit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function define(name, cls) { if (!customElements.get(name)) customElements.define(name, cls); }
  function fmt(s) { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }

  /* Aparición suave al hacer scroll */
  var fadeIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); fadeIO.unobserve(e.target); } });
  }, { threshold: 0.15 }) : null;
  function watchFades(root) {
    root.querySelectorAll('.rk-fade').forEach(function (el) { fadeIO ? fadeIO.observe(el) : el.classList.add('is-in'); });
  }

  /* Video */
  define('rk-video', class extends HTMLElement {
    connectedCallback() {
      watchFades(this);
      var v = this.querySelector('video'); if (!v) return;
      var box = this.querySelector('.rk-video'), time = this.querySelector('.rk-video__time'),
          bar = this.querySelector('.rk-video__progress span'), mute = this.querySelector('[data-rk-mute]'),
          full = this.querySelector('[data-rk-full]'), play = this.querySelector('.rk-video__play');
      v.removeAttribute('controls'); v.muted = true; v.playsInline = true;
      var toggle = function () { v.paused ? v.play() : v.pause(); };
      play && play.addEventListener('click', toggle);
      v.addEventListener('click', toggle);
      v.addEventListener('play', function () { box.classList.add('is-playing'); });
      v.addEventListener('pause', function () { box.classList.remove('is-playing'); });
      var tick = function () {
        if (time) time.textContent = fmt(v.currentTime) + ' / ' + fmt(v.duration);
        if (bar && v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%';
      };
      v.addEventListener('timeupdate', tick); v.addEventListener('loadedmetadata', tick);
      mute && mute.addEventListener('click', function () { v.muted = !v.muted; mute.classList.toggle('is-on', !v.muted); });
      full && full.addEventListener('click', function () {
        if (v.requestFullscreen) v.requestFullscreen(); else if (v.webkitEnterFullscreen) v.webkitEnterFullscreen();
      });
      if (this.dataset.autoplay === 'true' && !reduce && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) v.play().catch(function () {}); else v.pause(); });
        }, { threshold: 0.4 }).observe(v);
      }
    }
  });

  /* Qué incluye: foto + producto sincronizados */
  define('rk-inside', class extends HTMLElement {
    connectedCallback() {
      watchFades(this);
      this.i = 0;
      this.media = this.querySelectorAll('.rk-inside__media .rk-inside__slide');
      this.cards = this.querySelectorAll('.rk-inside__card .rk-inside__slide');
      this.dots = this.querySelectorAll('.rk-inside__dot');
      this.prev = this.querySelector('.rk-inside__nav--prev');
      this.next = this.querySelector('.rk-inside__nav--next');
      this.n = this.cards.length; if (!this.n) return;
      var self = this;
      this.prev && this.prev.addEventListener('click', function () { self.go(self.i - 1); });
      this.next && this.next.addEventListener('click', function () { self.go(self.i + 1); });
      this.dots.forEach(function (d, k) { d.addEventListener('click', function () { self.go(k); }); });
      var x0 = null;
      this.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', function (e) {
        if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) self.go(self.i + (dx < 0 ? 1 : -1));
      });
      this.go(0);
    }
    go(k) {
      if (k < 0 || k >= this.n) return;
      this.i = k;
      [this.media, this.cards, this.dots].forEach(function (list) {
        list.forEach(function (el, j) { el.classList.toggle('is-active', j === k); el.setAttribute('aria-hidden', j === k ? 'false' : 'true'); });
      });
      if (this.prev) this.prev.disabled = k === 0;
      if (this.next) this.next.disabled = k === this.n - 1;
    }
  });

  /* Ingredientes: palabras que se van activando y cambian la foto */
  define('rk-ingredients', class extends HTMLElement {
    connectedCallback() {
      watchFades(this);
      var self = this;
      this.words = this.querySelectorAll('.rk-ing__word');
      this.slides = this.querySelectorAll('.rk-ing__slide');
      this.n = this.words.length; if (!this.n) return;
      this.ms = (parseFloat(this.dataset.interval) || 3.5) * 1000;
      this.words.forEach(function (w, k) {
        w.addEventListener('click', function () { self.set(k); self.restart(); });
        w.addEventListener('mouseenter', function () { self.set(k); self.stop(); });
        w.addEventListener('focus', function () { self.set(k); self.stop(); });
      });
      this.addEventListener('mouseleave', function () { self.restart(); });
      this.set(0);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { e.isIntersecting ? self.restart() : self.stop(); });
        }, { threshold: 0.3 }).observe(this);
      }
    }
    set(k) {
      this.i = k;
      this.words.forEach(function (w, j) { w.classList.toggle('is-active', j === k); w.setAttribute('aria-pressed', j === k ? 'true' : 'false'); });
      this.slides.forEach(function (s, j) { s.classList.toggle('is-active', j === k); });
    }
    stop() { clearInterval(this.t); this.t = null; }
    restart() {
      this.stop(); if (reduce) return; var self = this;
      this.t = setInterval(function () { self.set((self.i + 1) % self.n); }, this.ms);
    }
    disconnectedCallback() { this.stop(); }
  });

  /* Resultados: carrusel con flechas */
  define('rk-results', class extends HTMLElement {
    connectedCallback() {
      watchFades(this);
      var track = this.querySelector('.rk-res__track'); if (!track) return;
      var prev = this.querySelector('.rk-res__nav--prev'), next = this.querySelector('.rk-res__nav--next');
      var step = function () { var c = track.querySelector('.rk-res__card'); return c ? c.getBoundingClientRect().width + 24 : 300; };
      var upd = function () {
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    }
  });

  /* Preguntas frecuentes */
  define('rk-faq', class extends HTMLElement {
    connectedCallback() {
      watchFades(this);
      this.querySelectorAll('.rk-faq__q').forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.rk-faq__item'), open = !item.classList.contains('is-open');
          item.classList.toggle('is-open', open);
          q.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }
  });

  /* Reciclaje: pestaña lateral */
  define('rk-recycling', class extends HTMLElement {
    connectedCallback() {
      watchFades(this);
      var box = this.querySelector('.rk-rec'), tab = this.querySelector('.rk-rec__tab'); if (!box || !tab) return;
      var label = tab.querySelector('span'), a = tab.dataset.open, b = tab.dataset.close;
      tab.addEventListener('click', function () {
        var open = !box.classList.contains('is-open');
        box.classList.toggle('is-open', open);
        tab.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (label) label.textContent = open ? b : a;
      });
    }
  });
})();